<template>
  <label :for="name">
    <with-error-message :show-error="!!errorMessage"
                      :character-limit="customLengthLimit || maxLength"
                      :character-count="validatedValue ? validatedValue.length : value.length"
    >
      <vx-tooltip :text="labelHint" position="top" class="w-max" :enabled="!!labelHint">
        {{ label }}
      </vx-tooltip>

      <base-input v-on="$listeners"
                  v-bind="inheritedProps"
                  ref="input"
                  :is-autofocus="isAutofocus"
                  :id="name"
                  :placeholder="placeholder"
                  :value="value"
                  :variant="!!errorMessage ? 'editor-soft-error' : 'editor-soft'"
                  :disabled="isDisabled"
                  :class="{'cursor-not-allowed': isDisabled}"
      />
    </with-error-message>
  </label>
</template>

<script>
import CharacterCounter from '@/components/editor/message/CharacterCounter.vue'
import BaseInput from '@/components/base-components/BaseInput.vue'
import InputErrorMessage from '@/components/base-components/InputErrorMessage.vue'
import WithErrorMessage from '@/components/common/WithErrorMessage.vue'

export default {
  name: 'ValidatedInput',

  components: {
    InputErrorMessage,
    CharacterCounter,
    BaseInput,
    WithErrorMessage
  },

  props: {
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    maxLength: {
      type: [Number, null],
      default: 0
    },
    customLengthLimit: {
      type: [Number, null],
      default: 0
    },
    value: {
      type: String,
      required: true
    },
    labelHint: {
      type: String,
      default: ''
    },
    errorMessage: {
      type: [String, Boolean], // is possible to send false in case of no error
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isAutofocus: {
      type: Boolean,
      default: false
    },
    validatedValue: {
      type: String,
      default: ''
    }
  },

  computed: {
    inheritedProps() {
      if (this.maxLength) return { ...this.$attrs, maxlength: this.maxLength }

      return { ...this.$attrs }
    }
  },

  watch: {
    errorMessage: {
      immediate: true,
      async handler(errorMessage) {
        if (!errorMessage) return

        await this.$nextTick()
        this.$refs.input.$el.focus()
      }
    }
  }
}
</script>

<style scoped lang="scss">
label {
  @apply flex flex-col font-bold text-sm;
}

input {
  @apply h-10 mt-1;
}
</style>
